import axios, { AxiosResponse } from "axios";

export const renewalService = {
  saveRenewalDate: (
    paymentRef: string,
    renewalDate: Date
  ): Promise<AxiosResponse<any>> => {
    return axios.put(`/policy/${paymentRef}/renewal`, {
      renewalDate: renewalDate
    });
  }
};
